<template>
  <footer class="layout-section layout-section--dark layout-section--footer">
    <p v-if="authUser" class="pb-1">
      <router-link to="/refer">Refer a Friend to Pixapup!</router-link>
    </p>
    <p>&copy; {{ currentYear }} Pixapup | New Media Now, LLC</p>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TheFooter',
  computed: {
    ...mapGetters('auth', ['authUser']),
    currentYear: function () {
      return new Date().getFullYear();
    },
  },
};
</script>

<style>
</style>